import { request } from '@/plugins/http';
/**
 * 指令配置列表
 * @param params
 * @returns {AxiosPromise}
 */
const getDataInstructList = params => request('/instruct/getDataInstructList', params);

/**
 * 新增
 * @param params
 * @returns {AxiosPromise}
 */
const addDatavehicle = params => request('/instruct/addDataInstruct', params);

/**
 * 修改
 * @param params
 * @returns {AxiosPromise}
 */
const updateDataInstruct = params => request('/instruct/updateDataInstruct', params);

/**
 * 删除
 * @param params
 * @returns {AxiosPromise}
 */
const delDataInstructs = params => request('/instruct/delDataInstructs', params);

/**
 * 导出模板
 * @param params
 * @returns {AxiosPromise}
 */
const downloadModal = params => request('/instruct/downloadModal', params, 'blob');

/**
 * 导入文件
 * @param params
 * @returns {AxiosPromise}
 */
const uploadExcel = params => request('/instruct/uploadExcel', params);

/**
 * 导出文件
 * @param params
 * @returns {AxiosPromise}
 */
const download = params => request('/instruct/download', params, 'blob');

/**
 * 长度字典
 * @param params
 * @returns {AxiosPromise}
 */
const getDictList = params => request('/dict/getDictList', params);

export {
    getDataInstructList,downloadModal,uploadExcel,download,getDictList,addDatavehicle,delDataInstructs,updateDataInstruct
};
